<template>
  <div class="">
    <sms-create></sms-create>
  </div>
</template>

<script>
import SmsCreate from "@/components/profile/lisacomunica/sms/create.vue";
import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  components: {
    SmsCreate,
  },
  created() {
    this.notifyQueue({
      text: "Sms",
      path: "lisacomunica_template",
      tab: "Sms",
      level: 3,
    });
    this.notifyQueue({
      text: "Inserisci template sms",
      path: "sms.create",
      level: 4,
    });
  },
};
</script>
